export const TASK_STATUS_OPTIONS = [
    "Pending",
    "Scheduled",
    "ReadyForBilling",
    "Cancelled",
];

export const TASK_TIME_OPTIONS = [
    "",
    "8:00",
    "9:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00",
    "18:00",
    "19:00",
    "20:00",
    "21:00",
    "22:00",
];

function normalizePropertyId(property) {
    return property?.property_id ?? property?.id ?? "";
}

function normalizeNumber(value) {
    return value ?? 0;
}

function normalizeTimeValue(value) {
    return value || null;
}

function normalizePricingValue(value) {
    if (value === "" || value === null || value === undefined) {
        return null;
    }

    const parsedValue = Number(value);
    return Number.isNaN(parsedValue) ? null : parsedValue;
}

export function sortProperties(properties = []) {
    return properties.slice().sort((leftProperty, rightProperty) => {
        return (leftProperty.full_address || "").localeCompare(rightProperty.full_address || "");
    });
}

export function createEmptyTaskForm(initialDate, defaultWorkerId) {
    return {
        cos_job_id: "",
        property_id: "",
        full_address: "",
        key_number: "",
        description: "",
        date: initialDate,
        status: "Pending",
        cos_job_worker: defaultWorkerId,
        cos_customer_name: "",
        agent_name: "",
        phone: "",
        email: "",
        check_out: "",
        check_in: "",
        consumable_type: null,
        bedroom: 0,
        bathroom: 0,
        sofabed: 0,
        king: 0,
        queen: 0,
        single: 0,
        agent_price: "",
        worker_price: "",
        comments: "",
    };
}

export function buildTaskFormFromProperty(property, initialDate, defaultWorkerId) {
    return {
        cos_job_id: "",
        property_id: normalizePropertyId(property),
        full_address: property?.full_address || "",
        key_number: property?.key_number || "",
        description: "",
        date: initialDate,
        status: "Pending",
        cos_job_worker: defaultWorkerId,
        cos_customer_name: property?.cos_customer_name || "",
        agent_name: property?.agent_name || property?.cos_customer_name || "",
        phone: property?.phone || "",
        email: property?.email || "",
        check_out: property?.check_out || "",
        check_in: property?.check_in || "",
        consumable_type: property?.consumable_type ?? null,
        bedroom: normalizeNumber(property?.bedroom),
        bathroom: normalizeNumber(property?.bathroom),
        sofabed: normalizeNumber(property?.sofabed),
        king: normalizeNumber(property?.king),
        queen: normalizeNumber(property?.queen),
        single: normalizeNumber(property?.single),
        agent_price: "",
        worker_price: "",
        comments: "",
    };
}

export function buildTaskFormFromJob(job) {
    return {
        cos_job_id: job?.cos_job_id || "",
        property_id: normalizePropertyId(job),
        full_address: job?.full_address || "",
        key_number: job?.key_number || "",
        description: job?.description || "",
        date: job?.date || "",
        status: job?.status || "Pending",
        cos_job_worker: job?.cos_job_worker || "",
        cos_customer_name: job?.cos_customer_name || "",
        agent_name: job?.agent_name || "",
        phone: job?.phone || "",
        email: job?.email || "",
        check_out: job?.check_out || "",
        check_in: job?.check_in || "",
        consumable_type: job?.consumable_type ?? null,
        bedroom: normalizeNumber(job?.bedroom),
        bathroom: normalizeNumber(job?.bathroom),
        sofabed: normalizeNumber(job?.sofabed),
        king: normalizeNumber(job?.king),
        queen: normalizeNumber(job?.queen),
        single: normalizeNumber(job?.single),
        agent_price: "",
        worker_price: "",
        comments: "",
    };
}

export function buildTaskCreatePayload(taskForm) {
    return {
        property_id: taskForm.property_id,
        full_address: taskForm.full_address,
        key_number: taskForm.key_number,
        job_type: "Task",
        description: taskForm.description,
        cos_customer_name: taskForm.cos_customer_name,
        agent_name: taskForm.agent_name,
        phone: taskForm.phone,
        email: taskForm.email,
        date: taskForm.date,
        check_out: normalizeTimeValue(taskForm.check_out),
        check_in: normalizeTimeValue(taskForm.check_in),
        consumable_type: taskForm.consumable_type,
        bedroom: taskForm.bedroom,
        bathroom: taskForm.bathroom,
        sofabed: taskForm.sofabed,
        king: taskForm.king,
        queen: taskForm.queen,
        single: taskForm.single,
    };
}

export function buildTaskAdminPayload(taskForm) {
    return {
        cos_job_id: taskForm.cos_job_id,
        key_number: taskForm.key_number,
        job_type: "Task",
        description: taskForm.description,
        cos_customer_name: taskForm.cos_customer_name,
        agent_name: taskForm.agent_name,
        phone: taskForm.phone,
        email: taskForm.email,
        date: taskForm.date,
        status: taskForm.status,
        cos_job_worker: taskForm.cos_job_worker,
        check_out: normalizeTimeValue(taskForm.check_out),
        check_in: normalizeTimeValue(taskForm.check_in),
        consumable_type: taskForm.consumable_type,
        bedroom: taskForm.bedroom,
        bathroom: taskForm.bathroom,
        sofabed: taskForm.sofabed,
        king: taskForm.king,
        queen: taskForm.queen,
        single: taskForm.single,
    };
}

export function buildTaskPricingPayload(taskForm) {
    return {
        cos_job_id: taskForm.cos_job_id,
        total_override_price: normalizePricingValue(taskForm.agent_price),
        labour_override_price: normalizePricingValue(taskForm.worker_price),
        comments: taskForm.comments ?? "",
    };
}
